/* c8 ignore start */
/* Feature Flags File */
import get from "lodash/get";

export const FLAG_2393_SHIFT_COVER = "VITE_FLAG_2393_SHIFT_COVER";

export const FEATURE_FLAGS = {
  [FLAG_2393_SHIFT_COVER]:
    get(import.meta.env, FLAG_2393_SHIFT_COVER, "true") === "true",
};

export const isFeatureEnabled = (flag) => {
  return get(FEATURE_FLAGS, flag, false);
};
/* c8 ignore end */
